'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _analytics = require('@pcln/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  appName: _propTypes2.default.string.isRequired,
  appVersion: _propTypes2.default.string.isRequired,
  debugMode: _propTypes2.default.bool,
  gaEnabled: _propTypes2.default.bool,
  storyMode: _propTypes2.default.bool,
  gaCategory: _propTypes2.default.string,
  children: _propTypes2.default.node.isRequired
};

var defaultProps = {
  debugMode: false,
  gaEnabled: true,
  storyMode: false
};

var childContextTypes = {
  analytics: _propTypes2.default.shape({
    // logSplunkEvent: PropTypes.func,
    // logSetiDimension: PropTypes.func,
    logEvent: _propTypes2.default.func,
    // logError: PropTypes.func,
    // logWarning: PropTypes.func,
    gaCategory: _propTypes2.default.string,
    // appName: PropTypes.string,
    // appVersion: PropTypes.string,
    // productID: PropTypes.string,
    debugMode: _propTypes2.default.bool,
    gaEnabled: _propTypes2.default.bool,
    storyMode: _propTypes2.default.bool
  })
};

var AnalyticsProvider = function (_React$Component) {
  _inherits(AnalyticsProvider, _React$Component);

  function AnalyticsProvider(props) {
    _classCallCheck(this, AnalyticsProvider);

    var _this = _possibleConstructorReturn(this, (AnalyticsProvider.__proto__ || Object.getPrototypeOf(AnalyticsProvider)).call(this, props));

    _analytics2.default.appName = props.appName;

    _analytics2.default.appVersion = props.appVersion;

    // if (props.productId) {
    //   PCLNAnalytics.productID = props.productId
    // }
    if (props.debugMode) {
      _analytics2.default.debugMode = props.debugMode;
    }
    if (props.gaEnabled) {
      _analytics2.default.gaEnabled = props.gaEnabled;
    }

    // this.logSplunkEvent = this.logSplunkEvent.bind(this)
    // this.logSetiDimension = this.logSetiDimension.bind(this)
    _this.logEvent = _this.logEvent.bind(_this);
    // this.logError = this.logError.bind(this)
    // this.logWarning = this.logWarning.bind(this)
    return _this;
  }

  // logSplunkEvent (logObject) {
  //   if (this.props.storyMode) {
  //     console.log('Log Splunk Event:\n\nApp:', this.context.appName || this.props.appName, '\nVersion:', this.context.appVersion || this.props.appVersion, '\nEvent Logged:', logObject)
  //   } else {
  //     PCLNAnalytics.log(logObject)
  //   }
  // }

  // logSetiDimension (logObject) {
  //   if (this.props.storyMode) {
  //     console.log('Log Seti Dimension:\n\nApp:', this.props.appName, '\nVersion:', this.context.appVersion || this.props.appVersion, '\nEvent Logged:', logObject)
  //   } else {
  //     PCLNAnalytics.logSeti(logObject)
  //   }
  // }

  _createClass(AnalyticsProvider, [{
    key: 'logEvent',
    value: function logEvent(logObject) {
      if (this.props.storyMode) {
        console.log('Log GA Event:\n\nApp:', this.context.appName || this.props.appName, '\nVersion:', this.context.appVersion || this.props.appVersion, '\nEvent Logged:', logObject);
      } else {
        _analytics2.default.logEvent(logObject);
      }
    }

    // logError (logObject) {
    //   if (this.props.storyMode) {
    //     console.log('Log Error:\n\nApp:', this.context.appName || this.props.appName, '\nVersion:', this.context.appVersion || this.props.appVersion, '\nEvent Logged:', logObject)
    //   } else {
    //     PCLNAnalytics.logError(logObject)
    //   }
    // }

    // logWarning (logObject) {
    //   if (this.props.storyMode) {
    //     console.log('Log Warning:\n\nApp:', this.context.appName || this.props.appName, '\nVersion:', this.context.appVersion || this.props.appVersion, '\nEvent Logged:', logObject)
    //   } else {
    //     PCLNAnalytics.logWarning(logObject)
    //   }
    // }

  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        analytics: {
          // logSplunkEvent: this.logSplunkEvent,
          // logSetiDimension: this.logSetiDimension,
          logEvent: this.logEvent,
          // logError: this.logError,
          // logWarning: this.logWarning,
          gaCategory: this.props.gaCategory
          // appName: this.props.appName || this.context.analytics.appName,
          // appVersion: this.props.appVersion || this.context.analytics.appVersion,
          // productID: this.props.productID || this.context.analytics.productID
        }
      };
    }
  }, {
    key: 'render',
    value: function render() {
      // `Children.only` enables us not to add a <div /> for nothing
      return _react2.default.Children.only(this.props.children);
    }
  }]);

  return AnalyticsProvider;
}(_react2.default.Component);

AnalyticsProvider.propTypes = propTypes;
AnalyticsProvider.defaultProps = defaultProps;
AnalyticsProvider.childContextTypes = childContextTypes;

exports.default = AnalyticsProvider;